import { Injectable } from '@angular/core';
import { AccountDateFilterRequest } from '../../../_shared/models/accountDateFilter.model';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { FuelChangesLocationsResponse } from '../models/fuel-changes-details.model';
import { environment } from '../../../../environments/environment';
import { Response } from '../../../_shared/models';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FuelChangesMapService {

  constructor(private http: HttpClient) { }

  async getFuelChangesLocations(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<FuelChangesLocationsResponse[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/fueldashboard/fuel-changes-locations`, request).pipe(takeUntil(cancellation)));
  }
}